import CryptoWallets from './CryptoWallets';
import Cards from './Cards';

const CardsAndWallets = ({ activeChildTab }) => (
  <>
    {activeChildTab === 0 && <CryptoWallets />}
    {activeChildTab === 1 && <Cards />}
  </>
);

export default CardsAndWallets;
